import { db, firebaseAuth } from './firebaseConfig';
import I18n from 'core/I18n/I18n';
import keyEnum from 'core/I18n/KeyEnum';
import EntityEnum from './EntityEnum';
import { getItem, addItem, deleteItem, updateItem } from './firebaseFunctions';


export const getGroup = async (fields) => {
    return getItem("Groups", fields);
}

export const addGroup = async (item) => {
    return addItem("Groups", item);
}

export const deleteGroup = async (id) => {
    return deleteItem("Groups", id);
}

export const updateGroup = async (item) => {
    return updateItem("Groups", item);
}



/**
 * const users = db.collection(EntityEnum.user);
    const query = users.where('invite', '==', true);

    return query.get().then(snapshot => {
        if (snapshot.empty) {
            return;
        } else {
            snapshot.docs.forEach(document => {
                if (document.exists && document.id === id) {
                    return document;
                } else {
                    throw new Error(I18n[keyEnum.inviteExpired]);
                }
            });
            return;
        }
    })
 */